import React, { useState } from 'react';
import { Layout, Image, Flex, Typography, Menu } from 'antd';
import './pageLayout.less'
import logo from '../static/logo.png'
import phone from '../static/phone.png'
import type { MenuProps } from 'antd';
import public_security_icon from '../static/public_security_icon.png'
type MenuItem = Required<MenuProps>['items'][number];
const { Header, Content, Sider, Footer } = Layout;
const { Title, Text, Link } = Typography;

const items: any[] = [
  {
    label: '首页',
    key: 'menu1',
    path: ''
  },
  {
    label: '关于我们',
    key: 'menu2',
    children: [
      { label: '基金会简介', key: 'menu21', path: 'foundation-intro' },
      { label: '理事会、监事会成员信息', key: 'menu22', path: 'board-members' },
      { label: '合作伙伴', key: 'menu23', path: 'volunteer' },
      { label: '荣誉认证', key: 'menu24', path: 'honors' }
    ],
  },
  {
    label: '新闻资讯',
    key: 'menu3',
    children: [
      { label: '机构动态', key: 'menu31', path: 'institutional-news' },
      { label: '行业动态', key: 'menu32', path: 'industry-news' }
    ],
  },
  {
    label: '党建专栏',
    key: 'menu4',
    children: [
      { label: '党建活动', key: 'menu41', path: 'party-activities' },
      { label: '清廉园地', key: 'menu42', path: 'integrity-construction' }
    ],
  },
  {
    label: '公益项目',
    key: 'menu5',
    children: [
      { label: '爱心助学', key: 'menu51', path: 'love-aid-for-education' },
      { label: '心理健康科普校园宣讲员', key: 'menu52', path: 'mental-health-campus-ambassador' }
    ],
  },
  {
    label: '信息披露',
    key: 'menu6',
    children: [
      { label: '规章制度', key: 'menu61', path: 'regulations' },
      { label: '捐赠公示', key: 'menu62', path: 'donation-disclosure' },
      { label: '年度报告', key: 'menu63', path: 'annual-reports' },
      { label: '审计报告', key: 'menu64', path: 'audit-reports' },
      { label: '章程', key: 'menu65', path: 'constitution' },
      { label: '公益性捐赠税前扣除资格', key: 'menu66', path: 'donation-tax-qualification' }
    ],
  },
  {
    label: '联系我们',
    key: 'menu7',
    path: 'contact'
  }
];

type PageOwnProps = {
  children: React.ReactNode[];
  Content: any,
  history: any
}

type PageState = {
  collapsed: boolean,
  current: string
}



class PageLayout extends React.Component<PageOwnProps, PageState> {

  constructor(props: any, context: any) {
    super(props, context)
    this.state = {
      collapsed: false,
      current: ''
    }
  }

  componentDidMount() {
    const path = this.props.history.location.pathname.substring(1);
    const findItemByPath = (menuItems: any[], path: string) => {
      for (const item of menuItems) {
        if (item.path === path) {
          return item.key;
        }
        if (item.children) {
          const found:any[] = findItemByPath(item.children, path);
          if (found) return found;
        }
      }
    };
    this.setState({ current: findItemByPath(items, path) });
  }



  onChange(value: any) {
    if (this.props.history.location.pathname !== '/') {
      this.goHome();
      this.setState({ current: 'menu1' }); // 重置菜单选中状态
    }
  }


  goHome() {
    this.props.history.push('/')
  }
  changeMenu(e: any) {
    const findItemByKey = (menuItems: any[] | null | undefined, key: string) => {
      if (!menuItems) return null;
      for (const item of menuItems) {
        if (item.key === key) {
          return item;
        }
        if (item.children) {
          const found:any[] = findItemByKey(item.children, key);
          if (found) return found;
        }
      }
      return null;
    };

    const selectedItem = findItemByKey(items, e.key);
    if (selectedItem) {
      this.setState({ current: e.key }, () => {
        if (selectedItem.path !== undefined) {
          this.props.history.push(`/${encodeURIComponent(selectedItem.path)}`);
        }
      });
    }
  }


  render() {
    const { current } = this.state
    console.log(this.props.history)
    return <Layout className='appcontent'>
      <Header style={{ 'backgroundColor': 'transparent', 'height': '80px' }}>
        <Flex style={{ 'height': '80px' }} justify={'space-between'} align={'center'}>
          <Flex gap={'small'} justify={'flex-start'} align={'center'}>
            <img style={{ 'lineHeight': '1', 'height': '50px' }} src={logo} />
            <Menu style={{ lineHeight: '32px', backgroundColor: 'transparent', 'borderBottom': 'none' }} onClick={this.changeMenu.bind(this)} selectedKeys={[current]} mode="horizontal" items={items} />
          </Flex>
          <Flex gap={'small'} justify={'flex-end'} align={'center'}>
            <img style={{ 'lineHeight': '1', 'height': '30px' }} src={phone} />
            <Title style={{ 'margin': '0' }} level={4}>18857167980</Title>
          </Flex>
        </Flex>
      </Header>
      <Content
        className="site-layout-background"
        style={{
          minHeight: 'calc(100vh - 80px - 200px)',
        }}
      >
        {this.props.Content}
      </Content>
      <Footer style={{ 'backgroundColor': '#222325', 'height': '200px', 'padding': '0' }}>
        <Flex style={{ 'height': '200px' }} vertical={true} justify={'center'} align={'center'}>
          <Flex gap={'middle'} style={{ 'height': '40px' }} vertical={false} justify={'center'} align={'center'}>
            <Text style={{ color: 'rgb(185,185,185)' }}>联系人：李莉</Text>
            <Text style={{ color: 'rgb(185,185,185)' }}>联系电话：18857167980</Text>
            <Text style={{ color: 'rgb(185,185,185)' }}>联系地址：杭州市余杭区闲林街道联荣路1-65号四楼</Text>
          </Flex>
          <Flex gap={'small'} style={{ 'height': '40px' }} vertical={false} justify={'center'} align={'center'}>
            <Text style={{ color: 'rgb(185,185,185)' }}>©2025 绿城爱心基金会 版权所有</Text>
            <img style={{ 'lineHeight': '1', 'height': '10px' }} src={public_security_icon} />
            <Link style={{ color: 'rgb(185,185,185)' }} href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">浙ICP备2024141102号-2</Link>
          </Flex>
        </Flex>
      </Footer>
    </Layout>
  }
}



export default PageLayout